export default "__VITE_ASSET__Bvcmj3L4__"